import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPriority = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(0 1.8462) scale(1.8462)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M4.37644 5.49994L0.0738381 0.496061C-0.0348084 0.369984 -0.0192621 0.180413 0.108449 0.072843C0.165363 0.0247393 0.235421 0.00155763 0.304642 0.00155763V0H8.22682C8.33111 0 8.42301 0.0515846 8.47799 0.130474L12.9277 5.30582C13.0265 5.42054 13.0225 5.58758 12.9253 5.69751L8.45782 10.8928C8.39813 10.9625 8.31252 10.9984 8.22701 10.9984V11H0.304838C0.136498 11 0 10.8649 0 10.6982C0 10.6127 0.0361839 10.5355 0.0939317 10.4803L4.37644 5.49994ZM0.962267 0.603255L8.22701 0.130474C8.32456 0.240425 8.18733 10.2819 8.08858 10.3966L0.304642 0L12.5 5.49994L0.962267 0.603255Z",
			fill: "currentColor"
		})
	})]
});
const ForwardRef = forwardRef(SvgPriority);
export default ForwardRef;
